module.exports = __webpack_public_path__ + "static/media/notes.618b84fa.svg";